import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-infotooltip',
  templateUrl: './infotooltip.component.html',
  styleUrls: ['./infotooltip.component.scss']
})
export class InfotooltipComponent implements OnInit {
  @Input() tooltipText: string;
  @Output() private infoIconClicked: EventEmitter<string> = new EventEmitter<string>();
  constructor() { }

  ngOnInit() {
  }

  showToolTip() {
    this.infoIconClicked.emit();
    const modal = document.getElementById('myModalInfoTip');
    modal.style.display = 'block';
  }
  close() {
    const modal = document.getElementById('myModalInfoTip');
    modal.style.display = 'none';
  }

}
